import { render, staticRenderFns } from "./editContract.vue?vue&type=template&id=b2d24db8"
import script from "./editContract.vue?vue&type=script&lang=js"
export * from "./editContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports